var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        fill: "#000000",
        height: "800px",
        width: "800px",
        version: "1.1",
        id: "Layer_1",
        viewBox: "0 0 299.847 299.847",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", [
        _c("g", [
          _c("path", {
            attrs: {
              d: "M257.583,118.126c-1.123-2.035-3.26-3.298-5.582-3.298H149.92V6.367c0-2.922-1.991-5.48-4.823-6.176    c-2.826-0.708-5.793,0.593-7.177,3.164l-95.7,178.64c-1.059,1.978-0.995,4.377,0.147,6.291c1.142,1.914,3.222,3.101,5.468,3.101    h89.32v102.08c0,2.839,1.882,5.334,4.613,6.131c0.581,0.159,1.18,0.249,1.767,0.249c2.15,0,4.211-1.097,5.41-2.967l108.46-172.26    C258.636,122.643,258.712,120.161,257.583,118.126z M149.914,271.361v-86.353c0-3.528-2.852-6.38-6.38-6.38H58.489l78.665-146.842    v89.422c0,3.528,2.852,6.38,6.38,6.38h96.899L149.914,271.361z",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }